import React from 'react';

import NumberFormat from 'react-number-format';
import { Dialog } from '../hooks/useDialog';
import Cal2 from './Calendar';
import Button from '@material-ui/core/Button';

import { months } from '../helpers/dateHelpers';
 
export function NumberFormatCustom(props) {
    const { inputRef, onChange, type = 'dollar', ...other } = props;

    if ( type !== 'percent') {
        return (
            <NumberFormat
                {...other}
                getInputRef={inputRef}
                // decimalScale={10} 
                onValueChange={values => {
                    onChange({
                        target: {
                            value: values.value,
                        },
                    });
                }}
                thousandSeparator
                prefix="$"
            />
        );
    }
    else if (type === 'percent') {
        return <NumberFormat
            {...other}
            getInputRef={inputRef}
            decimalScale={0}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.floatValue / 100,
                    },
                });
            }}
            allowNegative={false}
            suffix=" %"
        />
    }

}

export const padNumber = (value) => {
    return ('0' + value).slice(-2);
}

export const CalendarDialog = (props) => {

    const { dialogDate, dateClick = () => { } } = props;

    const month = dialogDate.getMonth() + 1;
    const year = dialogDate.getFullYear();

    const m = months.find(e => e.id.toString() === month.toString());

    return <Dialog options={{ maxWidth: 'lg' }} onClose={() => {
        dateClick();
    }} isCustomActions={true} actionButtons={[
        <div style={{ width: '100%', textAlign: 'right' }}>
            <Button onClick={() => dateClick()} variant={'text'} color={'primary'}>Cancel</Button>
        </div>
    ]}>
        <div style={{ height: 720 }}>
            <div style={{ display: 'flex' }}>
                <div style={{ width: '100%', textAlign: 'center' }}>
                    <div style={{ fontSize: 30 }}>{m.value}</div>
                    <div style={{ fontSize: 20 }}>{year}</div>
                </div>
            </div>
            <div style={{ display: 'flex' }}>
                <Cal2
                    date={dialogDate}
                    dateClick={(date) => {
                        dateClick(date);
                    }} />
            </div>
        </div>
    </Dialog>
}

export const groupBy = (itemArray, groupByPropertyName) => {
    var grouped = itemArray.reduce(function (rv, x) {
        (rv[x[groupByPropertyName]] = rv[x[groupByPropertyName]] || []).push(x);
        return rv;
    }, {});

    var ret = [];

    for (var x in grouped) {
        ret.push({ key: x, items: grouped[x] })
    }

    return ret;
};

export const defaultSorter = (a, b) => a > b ? 1 : a < b ? -1 : 0;

export const valueSort = (a, b, key, key2) => a[key] > b[key] ? 1 : a[key] < b[key] ? -1 : key2 ? a[key2] > b[key2] ? 1 : a[key2] < b[key2] ? -1 : 0 : 0;




// WEBPACK FOOTER //
// ./src/common/helpers.js